<template>
  <v-progress-linear
    bg-color="primary"
    color="primary"
    :model-value="(props.checkoutStage / 6) * 100"
    height="15"
    rounded="lg"
  ></v-progress-linear>
</template>
<script lang="ts" setup>
const props = defineProps<{ checkoutStage: number }>();
</script>
